import { z } from 'zod';
import { ROLES } from '@/types/user';

export const UserSchema = z.object({
  id: z.string().uuid(),
  givenName: z.string(),
  familyName: z.string(),
  email: z.string().email(),
  role: z.nativeEnum(ROLES),
  isActive: z.boolean(),
  siteId: z.string().optional(),
});

export const UserSnapshotSchema = z.object({
  id: z.string().uuid(),
  givenName: z.string(),
  familyName: z.string(),
  email: z.string().email(),
  role: z.object({
    code: z.nativeEnum(ROLES),
    name: z.string().optional(),
  }),
});

export type User = z.infer<typeof UserSchema>;
export type UserSnapshot = z.infer<typeof UserSnapshotSchema>;
